
import React, { useState } from 'react';

import {
    Chip,
    styled,
    Card,
    Grid,
    Stack,
    Button,
    Box,
    Typography,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    RadioGroup,
    FormControlLabel,
    Radio,
    Divider
} from '@mui/material';

import { useServerParams } from "../../../../hooks/useServerParams"

const CommonReportFiltersDisplay = ({ rules, dispatch, actionTypes }) => {

    const { getOperatorSymbol } = useServerParams()

    const handleDelete = ({ name }) => {
        dispatch({ type: actionTypes.removeRule, payload: name })
    }

    const getRuleLabel = ({ data }) => {
        return `${data?.nameDisplay.toUpperCase()} ${getOperatorSymbol(data?.operator)} ${data.valueDisplay}`
    }

    const Item = ({ data }) => {
        return (
            <Chip
                variant='outlined'
                size='medium'
                label={getRuleLabel({ data })}
                // onClick={handleClick}
                onDelete={() => {
                    handleDelete({ name: data?.name })
                }}
                sx={{
                    mr: 1,
                    mb: 1
                }}
            />
        )
    }

    return (
        <>
            {
                rules.map((i, index) => {
                    return (
                        <Item
                            key={index}
                            data={i}
                        />
                    )
                })
            }
        </>
    )
}

export {
    CommonReportFiltersDisplay,
}